import { addingSMSAutomationFlag } from '../../redux/slices/automation';
import { Close } from '@mui/icons-material';
import CustomDropdown from '../../components/reusable/dropdown';
import CustomInput from '../../components/reusable/input';
import { fieldsOptions } from '../../helper';
import LabelWrapper from '../../components/wrapper/label';
import { smsAutomationSchema } from '../../schema/automation_schema';
import { updateBuildAutomationThunk } from '../../redux/thunks/automation';
import { useRef } from 'react';
import { addNode, editSelectedNode, settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

interface SMSObject {
    type: 'phone' | 'condition' | 'email' | 'timer',
    action_name: string;
    message: string;
}

const SetSMSComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedNode } = useSelector((state: RootState) => state.workflow);
    const { loaders } = useSelector((state: RootState) => state.automation);
    const initialValues: SMSObject = {
        type: 'phone',
        action_name: (selectedNode?.data?.action_name as string) || '',
        message: (selectedNode?.data?.message as string) || ''
    };

    const handleBackNavigation = () => {
        dispatch(settingSelectedNode(null));
        dispatch(settingSelectedEdge(null));
        dispatch(addingSMSAutomationFlag(false));
    };

    const handleSubmit = async (value: SMSObject) => {
        if (selectedNode) {
            dispatch(editSelectedNode(value));
        } else {
            dispatch(addNode(value));
        }
        try {
            await dispatch(updateBuildAutomationThunk()).unwrap();
        } catch (e) {
            // Catch errors
        }
        handleBackNavigation();
    };


    return (<Box width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box></Box>
            <Typography variant="h3" fontWeight="bold" textAlign="center">{selectedNode ? 'Update' : 'Set'} SMS</Typography>
            <IconButton disabled={loaders.isUpdating} onClick={handleBackNavigation}><Close /></IconButton>
        </Box>
        <Box>
            <Formik
                initialValues={initialValues}
                validationSchema={smsAutomationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
                     const messageInputRef = useRef<HTMLTextAreaElement>(null);
                                    const handleAddField = (field: string) => {
                                        const textarea = messageInputRef.current;
                                        if (!textarea) {
                                            // fallback to appending
                                            setFieldValue('message', `${values.message} [${field}] `);
                                            return;
                                        }
                                        const start = textarea.selectionStart || 0;
                                        const end = textarea.selectionEnd || 0;
                                        const insertText = `[${field}]`;
                                        const newMessage =
                                            values.message.slice(0, start) +
                                            insertText +
                                            values.message.slice(end);
                                        setFieldValue('message', newMessage);

                                        // Restore focus and cursor after insertion
                                        setTimeout(() => {
                                            textarea.focus();
                                            const cursorPos = start + insertText.length;
                                            textarea.setSelectionRange(cursorPos, cursorPos);
                                        }, 0);
                                    };
                    return <Form>
                        <Box display="flex" flexDirection="column" gap={2}>
                            {/* Input for stage name */}
                            <CustomInput
                                value={values.action_name}
                                onChange={handleChange('action_name')}
                                onBlur={handleBlur('action_name')}
                                error={touched.action_name && errors.action_name}
                                fullWidth
                                label="Action name:"
                                placeholder="Type here"
                                variant="outlined"
                                disabled={loaders.isUpdating}
                                mandatoryFields={true}
                            />
                            {/* Input for days due */}
                            <Box display="flex" flexDirection="column" gap={2}>
                                <Box display="flex" justifyContent="space-between" alignItems="end">
                                    <LabelWrapper label="Message" sx={{ marginBottom: 0 }} />
                                    <Box>
                                        <CustomDropdown
                                            options={fieldsOptions}
                                            value=""
                                            placeholder="Add Field"
                                            onChange={(e) => handleAddField(e.target.value as string)}
                                            disabled={loaders.isUpdating}
                                            sx={{ marginBottom: '0' }}
                                        />
                                    </Box>
                                </Box>
                                <CustomInput
                                    type="textarea"
                                    value={values.message}
                                    onChange={handleChange('message')}
                                    onBlur={handleBlur('message')}
                                    error={touched.message && errors.message}
                                    fullWidth
                                    placeholder="Type here"
                                    variant="outlined"
                                    disabled={loaders.isUpdating}
                                    mandatoryFields={true}
                                    inputRef={messageInputRef}
                                />
                            </Box>
                            {/* Action buttons for cancel and submit */}
                            <Box display="flex" flexDirection="row-reverse" gap={2} mt={2}>
                                <Button type="submit" variant="contained" color="primary" disabled={loaders.isUpdating}>
                                {selectedNode && loaders.isUpdating ? 'Updating' : selectedNode ? 'Update' : loaders.isUpdating ? 'Creating' : 'Create'} action
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={handleBackNavigation} disabled={loaders.isUpdating}>
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    </Form>;
                }}
            </Formik>
        </Box>
    </Box>);
};

export default SetSMSComponent;